export default __webpack_public_path__ + "static/media/Kuthcheman Impaler.33ba2745.jpg";